<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="$store.appStore.isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="$store.appStore.isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="$store.appStore.isSidebarMinimized = !$store.appStore.isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page" class="logo">
          ED-EX Admin
        </RouterLink>
      </div>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="$store.appStore.isMobile" />
    </template>
  </VaNavbar>
</template>

<script>
import AppNavbarActions from './components/AppNavbarActions.vue'
export default {
  name: 'AppNavbar',
  components: { AppNavbarActions },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }
  }
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
.logo
{
  color: var(--va-primary);
  font-weight: bold;
  font-size: 1.5rem;
}
</style>
